var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dgth-container"},[_c('display-header',{attrs:{"loaded":this.loaded}}),_vm._v(" "),_c('full-calendar',{ref:"calendar",staticClass:"dgth-calendar",attrs:{"events":_vm.getEvents,"config":_vm.config}}),_vm._v(" "),_c('display-events')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3c946a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 381
// module chunks = 0